import styled from 'styled-components';
import { Avatar } from 'ui/avatar';
import { GhostButton, SecondaryButton } from 'ui/button';
import { colors, spacing, Subtitle2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

// Edit DetailsForm
export const ProfilePhotoSection = styled.div`
  display: grid;
  grid-template-areas: 'photo upload' 'photo remove';
  grid-template-columns: 80px 1fr;
  grid-template-rows: 1fr 1fr;
  row-gap: ${spacing.quarter};
`;

export const ProfilePhoto = styled(Avatar)`
  grid-area: photo;
`;

export const UploadButton = styled.div`
  grid-area: upload;
  justify-self: start;
`;

export const FileInput = styled.input`
  &[type='file'] {
    display: none;
  }
`;

export const RemoveButton = styled(GhostButton)`
  grid-area: remove;
  justify-self: start;
`;

export const ButtonsSection = styled.div`
  margin-top: ${spacing.plusHalf};
  & > *:first-of-type {
    margin-right: ${spacing.half};
  }
`;

// UserPreferencesPage
export const Section = styled.section`
  display: grid;
  grid-template-columns: 1fr 2fr;
  padding: ${spacing.double} 0;
`;

export const LeftDiv = styled.div`
  padding-right: ${pxToRem(80)};
`;

export const RightDiv = styled.div`
  border: solid 1px ${colors.grey15};
  border-radius: ${spacing.quarter};
  padding: ${spacing.double};
`;

const Content = styled.div`
  align-items: center;
  display: grid;
`;

export const ProfileContent = styled(Content)`
  grid-template-columns: ${pxToRem(60)} 1fr ${pxToRem(110)};
`;

export const SecurityContent = styled(Content)`
  grid-template-columns: 2fr 1fr;
`;

export const FullName = styled(Subtitle2)`
  margin-top: 0;
`;

export const ActionButton = styled(SecondaryButton)`
  justify-self: end;
`;
